// import React, { useContext, useEffect, useState, useCallback } from "react";
// import axios from "axios";
// import { FaPlus, FaSearch, FaEdit, FaTrash } from "react-icons/fa";
// import { API_URL } from "../../Constants";
// import { AuthContext } from "../context/AuthContext";

// const LeadSource = () => {
//   const { user } = useContext(AuthContext);
//   const [leadSources, setLeadSources] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [showFields, setShowFields] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [form, setForm] = useState({ name: "" });
//   const [editingSource, setEditingSource] = useState(null);
//   const [confirmDeleteId, setConfirmDeleteId] = useState(null);

//   const token = localStorage.getItem("token");
//   const companyId = user?.accountType === "COMPANY" ? user?.id : user?.companyId;

//   const fetchLeadSources = useCallback(async () => {
//     try {
//       const res = await axios.get(`${API_URL}/api/leadSource/company/${companyId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setLeadSources(res.data);
//     } catch (err) {
//       console.error("Failed to fetch lead sources", err);
//     }
//   }, [companyId, token]);

//   useEffect(() => {
//     fetchLeadSources();
//   }, [fetchLeadSources]);

//   // Add this function to handle toggle active/inactive
//   const handleToggleActive = async (id, currentActiveStatus) => {
//     try {
//       const newActiveStatus = !currentActiveStatus;
//       await axios.put(
//         `${API_URL}/api/leadSource/update/active/${id}?active=${newActiveStatus}&companyId=${companyId}`,
//         {},
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
      
//       // Update local state to reflect the change
//       setLeadSources(prevSources =>
//         prevSources.map(source =>
//           source.leadSourceId === id 
//             ? { ...source, active: newActiveStatus }
//             : source
//         )
//       );
//     } catch (err) {
//       console.error("Failed to update active status", err);
//       alert(err?.response?.data?.message || "Failed to update status");
//     }
//   };

//   const handleSave = async () => {
//     try {
//       if (editingSource) {
//         await axios.put(
//           `${API_URL}/api/leadSource/${editingSource.leadSourceId}`,
//           { name: form.name },
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//       } else {
//         await axios.post(
//           `${API_URL}/api/leadSource`,
//           { name: form.name, companyId, isDefault: false },
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//       }
//       closeModal();
//       fetchLeadSources();
//     } catch (err) {
//       console.error("Save failed", err);
//       alert(err?.response?.data?.message || "Failed to save");
//     }
//   };

//   const handleDelete = async () => {
//     try {
//       await axios.delete(`${API_URL}/api/leadSource/${confirmDeleteId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setConfirmDeleteId(null);
//       fetchLeadSources();
//     } catch (err) {
//       console.error("Delete failed", err);
//       alert(err?.response?.data?.message || "Delete failed");
//     }
//   };

//   const closeModal = () => {
//     setShowModal(false);
//     setForm({ name: "" });
//     setEditingSource(null);
//   };

//   return (
//     <div className="p-4 bg-gray-100 shadow-lg dark:bg-gray-900 dark:text-white">
//       <div className="flex justify-between items-center mb-4">
//         <h2 className="text-xl font-bold">Lead Source</h2>
//         <div className="flex gap-2">
//           <button
//             onClick={() => setShowModal(true)}
//             className="px-3 py-1 bg-indigo-600 text-white rounded hover:bg-indigo-700 flex items-center gap-2"
//           >
//             <FaPlus /> Add
//           </button>
//           <button
//             onClick={() => setShowFields(!showFields)}
//             className="px-3 py-1 bg-indigo-600 text-white rounded hover:bg-indigo-700 flex items-center gap-2"
//           >
//             <FaSearch />
//             {showFields ? "Close" : "Search"}
//           </button>
//         </div>
//       </div>

//       {showFields && (
//         <div className="mb-4 flex flex-wrap gap-2 items-center">
//           <input
//             type="text"
//             placeholder="Search by name..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="border px-3 py-2 rounded w-full md:w-1/3 dark:bg-gray-800 dark:text-white"
//           />
//           <button
//             onClick={() => {
//               const filtered = leadSources.filter((item) =>
//                 item.name.toLowerCase().includes(searchTerm.toLowerCase())
//               );
//               setLeadSources(filtered);
//             }}
//             className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
//           >
//             Search
//           </button>
//           <button
//             onClick={() => {
//               setSearchTerm("");
//               fetchLeadSources();
//             }}
//             className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400"
//           >
//             Clear
//           </button>
//         </div>
//       )}

//       <div className="overflow-x-auto">
//         <table className="w-full border">
//           <thead className="bg-gray-50 dark:bg-gray-800 dark:text-white">
//             <tr>
//               <th className="px-4 py-2 text-left">Source Name</th>
//               <th className="px-4 py-2 text-left">Default</th>
//               <th className="px-4 py-2 text-left">Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {leadSources.map((source) => (
//               <tr key={source.leadSourceId} className="border-t">
//                 <td className="px-4 py-2">{source.name}</td>
//                 <td className="px-4 py-2">
//                   {source.default ? (
//                     <span className="text-green-600 font-semibold">Yes</span>
//                   ) : (
//                     "No"
//                   )}
//                 </td>
//                 <td className="px-4 py-2 flex gap-4">
//                   {/* Professional Toggle Switch */}
//                   <div className="flex items-center">
//                     <button
//                       onClick={() => handleToggleActive(source.leadSourceId, source.active)}
//                       className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-300 ${
//                         source.active ? 'bg-green-500' : 'bg-gray-300'
//                       }`}
//                     >
//                       <span
//                         className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-300 ${
//                           source.active ? 'translate-x-6' : 'translate-x-1'
//                         }`}
//                       />
//                     </button>
//                     <span className={`ml-2 text-sm font-medium ${source.active ? 'text-green-600' : 'text-gray-500'}`}>
//                       {source.active ? 'Active' : 'Inactive'}
//                     </span>
//                   </div>
//                   {!source.default && (
//                     <>
//                       <button
//                         onClick={() => {
//                           setForm({ name: source.name });
//                           setEditingSource(source);
//                           setShowModal(true);
//                         }}
//                         className="text-yellow-500 hover:text-yellow-700"
//                       >
//                         <FaEdit />
//                       </button>
//                       <button
//                         onClick={() => setConfirmDeleteId(source.leadSourceId)}
//                         className="text-red-600 hover:text-red-800"
//                       >
//                         <FaTrash />
//                       </button>
//                     </>
//                   )}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* Modal for Add/Edit */}
//       {showModal && (
//          <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4 overflow-y-auto">
//           <div className="bg-white rounded-lg p-6 w-full max-w-md dark:bg-gray-800 dark:text-white">
//             <h2 className="text-xl font-bold mb-4 dark:text-white">
//               {editingSource ? "Edit" : "Create"} Lead Source
//             </h2>
//             <input
//               type="text"
//               value={form.name}
//               onChange={(e) => setForm({ name: e.target.value })}
//               className="w-full border px-3 py-2 mb-4 rounded dark:bg-gray-800 dark:text-white"
//               placeholder="Enter source name"
//             />
//             <div className="flex justify-end gap-2">
//               <button
//                 onClick={closeModal}
//                 className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400 dark:bg-gray-500"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleSave}
//                 className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
//               >
//                 {editingSource ? "Update" : "Create"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Confirm Delete */}
//       {confirmDeleteId && (
//          <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4 overflow-y-auto">
//           <div className="bg-white rounded-lg p-6 w-full max-w-sm dark:bg-gray-800 dark:text-white">
//             <h2 className="text-lg font-bold mb-4 text-center text-red-600">Confirm Delete</h2>
//             <p className="mb-4 text-center">Are you sure you want to delete this lead source?</p>
//             <div className="flex justify-end gap-2">
//               <button
//                 onClick={() => setConfirmDeleteId(null)}
//                 className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleDelete}
//                 className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default LeadSource;




import React, { useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { FaPlus, FaSearch, FaEdit, FaTrash } from "react-icons/fa";
import { API_URL } from "../../Constants";
import { AuthContext } from "../context/AuthContext";

const LeadSource = () => {
  const { user } = useContext(AuthContext);
  const [leadSources, setLeadSources] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showFields, setShowFields] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ name: "" });
  const [editingSource, setEditingSource] = useState(null);
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);

  const token = localStorage.getItem("token");
  const companyId = user?.accountType === "COMPANY" ? user?.id : user?.companyId;

  const fetchLeadSources = useCallback(async () => {
    try {
      const res = await axios.get(`${API_URL}/api/leadSource/company/${companyId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLeadSources(res.data);
    } catch (err) {
      console.error("Failed to fetch lead sources", err);
    }
  }, [companyId, token]);

  useEffect(() => {
    fetchLeadSources();
  }, [fetchLeadSources]);

  // Add this function to handle toggle active/inactive
  const handleToggleActive = async (id, currentActiveStatus) => {
    try {
      const newActiveStatus = !currentActiveStatus;
      await axios.put(
        `${API_URL}/api/leadSource/update/active/${id}?active=${newActiveStatus}&companyId=${companyId}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      // Update local state to reflect the change
      setLeadSources(prevSources =>
        prevSources.map(source =>
          source.leadSourceId === id 
            ? { ...source, active: newActiveStatus }
            : source
        )
      );
    } catch (err) {
      console.error("Failed to update active status", err);
      alert(err?.response?.data?.message || "Failed to update status");
    }
  };

  const handleSave = async () => {
    try {
      if (editingSource) {
        await axios.put(
          `${API_URL}/api/leadSource/${editingSource.leadSourceId}`,
          { name: form.name },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } else {
        await axios.post(
          `${API_URL}/api/leadSource`,
          { name: form.name, companyId, isDefault: false },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }
      closeModal();
      fetchLeadSources();
    } catch (err) {
      console.error("Save failed", err);
      alert(err?.response?.data?.message || "Failed to save");
    }
  };

  const handleDelete = async () => {
    try {
      await axios.delete(`${API_URL}/api/leadSource/${confirmDeleteId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setConfirmDeleteId(null);
      fetchLeadSources();
    } catch (err) {
      console.error("Delete failed", err);
      alert(err?.response?.data?.message || "Delete failed");
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setForm({ name: "" });
    setEditingSource(null);
  };

  return (
    <div className="p-4 bg-[#FAF8FF] shadow-lg cfg-font dark:bg-gray-900 dark:text-white">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap'); .cfg-heading{font-family:'Sora',sans-serif;color:#1F2937;} .cfg-font{font-family:'Inter',sans-serif;}`}</style>
            <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold cfg-heading">Lead Source</h2>
        <div className="flex gap-2">
          <button
            onClick={() => setShowModal(true)}
            className="px-3 py-1 bg-[#673AB7] text-white rounded hover:bg-[#5E35A6] flex items-center gap-2"
          >
            <FaPlus /> Add
          </button>
          <button
            onClick={() => setShowFields(!showFields)}
            className="px-3 py-1 bg-[#673AB7] text-white rounded hover:bg-[#5E35A6] flex items-center gap-2"
          >
            <FaSearch />
            {showFields ? "Close" : "Search"}
          </button>
        </div>
      </div>

      {showFields && (
        <div className="mb-4 flex flex-wrap gap-2 items-center">
          <input
            type="text"
            placeholder="Search by name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="border border-[#E5E7EB] px-3 py-2 rounded w-full md:w-1/3 dark:bg-gray-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7]"
          />
          <button
            onClick={() => {
              const filtered = leadSources.filter((item) =>
                item.name.toLowerCase().includes(searchTerm.toLowerCase())
              );
              setLeadSources(filtered);
            }}
            className="bg-[#673AB7] text-white px-4 py-2 rounded hover:bg-[#5E35A6]"
          >
            Search
          </button>
          <button
            onClick={() => {
              setSearchTerm("");
              fetchLeadSources();
            }}
            className="bg-[#F3F4F6] text-[#374151] px-4 py-2 rounded hover:bg-[#E5E7EB]"
          >
            Clear
          </button>
        </div>
      )}

      <div className="overflow-x-auto">
        <table className="w-full border border-[#E5E7EB] rounded-lg overflow-hidden">
          <thead className="bg-[#F3F4F6] dark:bg-gray-800 dark:text-white">
            <tr>
              <th className="px-4 py-2 text-left">Source Name</th>
              <th className="px-4 py-2 text-left">Default</th>
              <th className="px-4 py-2 text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {leadSources.map((source) => (
              <tr key={source.leadSourceId} className="border-t">
                <td className="px-4 py-2">{source.name}</td>
                <td className="px-4 py-2">
                  {source.default ? (
                    <span className="text-green-600 font-semibold">Yes</span>
                  ) : (
                    "No"
                  )}
                </td>
                <td className="px-4 py-2 flex gap-4">
                  {/* Professional Toggle Switch */}
                  <div className="flex items-center">
                    <button
                      onClick={() => handleToggleActive(source.leadSourceId, source.active)}
                      className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-300 ${
                        source.active ? 'bg-green-500' : 'bg-gray-300'
                      }`}
                    >
                      <span
                        className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-300 ${
                          source.active ? 'translate-x-6' : 'translate-x-1'
                        }`}
                      />
                    </button>
                    <span className={`ml-2 text-sm font-medium ${source.active ? 'text-green-600' : 'text-gray-500'}`}>
                      {source.active ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                  {!source.default && (
                    <>
                      <button
                        onClick={() => {
                          setForm({ name: source.name });
                          setEditingSource(source);
                          setShowModal(true);
                        }}
                        className="text-[#8B5CF6] hover:text-[#673AB7]"
                      >
                        <FaEdit />
                      </button>
                      <button
                        onClick={() => setConfirmDeleteId(source.leadSourceId)}
                        className="text-[#EF4444] hover:text-[#B91C1C]"
                      >
                        <FaTrash />
                      </button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal for Add/Edit */}
      {showModal && (
         <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4 overflow-y-auto">
          <div className="bg-white rounded-xl p-6 w-full max-w-md dark:bg-gray-800 dark:text-white shadow-xl">
            <h2 className="text-xl font-bold mb-4 cfg-heading dark:text-white">
              {editingSource ? "Edit" : "Create"} Lead Source
            </h2>
            <input
              type="text"
              value={form.name}
              onChange={(e) => setForm({ name: e.target.value })}
              className="w-full border border-[#E5E7EB] px-3 py-2 mb-4 rounded dark:bg-gray-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7]"
              placeholder="Enter source name"
            />
            <div className="flex justify-end gap-2">
              <button
                onClick={closeModal}
                className="px-4 py-2 bg-[#F3F4F6] text-[#374151] rounded hover:bg-[#E5E7EB] dark:bg-gray-500"
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                className="px-4 py-2 bg-[#673AB7] text-white rounded hover:bg-[#5E35A6]"
              >
                {editingSource ? "Update" : "Create"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Confirm Delete */}
      {confirmDeleteId && (
         <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4 overflow-y-auto">
          <div className="bg-white rounded-xl p-6 w-full max-w-sm dark:bg-gray-800 dark:text-white shadow-xl">
            <h2 className="text-lg font-bold mb-4 cfg-heading text-center text-[#EF4444]">Confirm Delete</h2>
            <p className="mb-4 text-center">Are you sure you want to delete this lead source?</p>
            <div className="flex justify-end gap-2">
              <button
                onClick={() => setConfirmDeleteId(null)}
                className="px-4 py-2 bg-[#F3F4F6] text-[#374151] rounded hover:bg-[#E5E7EB]"
              >
                Cancel
              </button>
              <button
                onClick={handleDelete}
                className="px-4 py-2 bg-[#EF4444] text-white rounded hover:bg-[#B91C1C]"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LeadSource;